interface LogoProps {
  size?: number;
  className?: string;
}

export default function Logo({ size = 32, className = "" }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="7" fill="hsl(217 80% 42%)" />
      <ellipse
        cx="16"
        cy="16"
        rx="6.5"
        ry="7.5"
        stroke="white"
        strokeWidth="3.6"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
